import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { BMEventsType } from '../types';
import { BaseMetric, MetricState } from './base-metric';
export var WebVitalsMetric = /*#__PURE__*/function (_BaseMetric) {
  _inherits(WebVitalsMetric, _BaseMetric);
  var _super = _createSuper(WebVitalsMetric);
  function WebVitalsMetric(_ref) {
    var _this;
    var key = _ref.key,
      route = _ref.route,
      startTime = _ref.startTime,
      stopTime = _ref.stopTime,
      pageVisibleState = _ref.pageVisibleState;
    _classCallCheck(this, WebVitalsMetric);
    _this = _super.call(this, {
      type: BMEventsType.WEB_VITALS,
      key: key
    });
    _this.route = route;
    _this.startTime = startTime;
    _this.stopTime = stopTime;
    _this.state = MetricState.FINISHED;
    _this.pageVisibleState = pageVisibleState;
    return _this;
  }
  return _createClass(WebVitalsMetric);
}(BaseMetric);